(function () {
  'use strict';

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]+/g, ' ')
      .toLowerCase()
      .trim();
  }

  function track(context) {
    if (window.PxmAnalytics) window.PxmAnalytics.track('library_search_used', context);
  }

  function process(container) {
    if (!container || container.dataset.pxmSearchReady === 'true') return;
    container.dataset.pxmSearchReady = 'true';
    const query = normalize(container.dataset.query);
    if (!query) return;
    const words = query.split(/\s+/).filter(Boolean);
    const limit = container.dataset.mode === 'predictive' ? 5 : 12;
    const items = Array.from(container.querySelectorAll('[data-pxm-search-guide]'));
    const seen = new Set();
    let visible = 0;

    items.forEach(function (item) {
      const haystack = normalize(item.dataset.search + ' ' + item.textContent);
      const matches = words.every(function (word) { return haystack.includes(word); });
      const key = item.dataset.guideId || normalize(item.textContent);
      const show = matches && !seen.has(key) && visible < limit;
      item.hidden = !show;
      if (show) {
        seen.add(key);
        visible += 1;
      }
    });

    container.hidden = visible === 0;
    const empty = container.querySelector('[data-pxm-search-guides-empty]');
    if (empty) empty.hidden = visible > 0;
    container.addEventListener('click', function (event) {
      if (!event.target.closest('[data-pxm-search-guide-link]')) return;
      track({ query_length: query.length, result_count: visible, source: container.dataset.mode || 'full' });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pxm-search-guides]').forEach(process);
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-pxm-search-guides]')) process(node);
        init(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    init(document);
    observer.observe(document.body, { childList: true, subtree: true });
  }
}());
